<template>
  <p class="text-text-secondary">{{ label }}</p>
  <v-radio-group v-model="computedValue">
    <v-radio :label="$t('profile.views.Settings.notifyImmediately')" :value="NOTIFICATIONS_FREQUENCY.GRADUALLY" />
    <v-radio :label="$t('profile.views.Settings.notifyEveryMorning')" :value="NOTIFICATIONS_FREQUENCY.MORNING" />
    <v-radio :label="$t('profile.views.Settings.notifyEveryEvening')" :value="NOTIFICATIONS_FREQUENCY.EVENING" />
    <v-radio :label="$t('profile.views.Settings.notifyDisable')" :value="NOTIFICATIONS_FREQUENCY.NEVER" />
  </v-radio-group>
</template>


<script lang="ts">
import { defineComponent, PropType } from 'vue'

const NOTIFICATIONS_FREQUENCY = {
  GRADUALLY: 'gradually',
  MORNING: 'morning',
  EVENING: 'evening',
  NEVER: 'never',
} as const

type NotificationFrequency = (typeof NOTIFICATIONS_FREQUENCY)[keyof typeof NOTIFICATIONS_FREQUENCY]

export default defineComponent({
  name: 'NotificationSettings',
  props: {
    modelValue: {
      type: String as PropType<NotificationFrequency>,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
  },
  emits: ['settings-changed', 'update:model-value'],
  data () {
    return {
      NOTIFICATIONS_FREQUENCY,
    }
  },
  computed: {
    computedValue: {
      get () {
        return this.modelValue
      },
      set (newValue: NotificationFrequency) {
        this.$emit('update:model-value', newValue)
        this.$emit('settings-changed')
      },
    },
  },
})
</script>
